import { createSlice } from '@reduxjs/toolkit';

// Billing form state used to live here and was re-dispatched on every
// keystroke (including a non-serializable `trigger` function, which is why the
// store had to disable serializableCheck). It now lives in the form itself and
// is read on demand via CheckoutFormContext, so only the payment preferences
// remain.
const initialState = {
	paymentType: 'recurring',
	paymentMethod: 'upi',
};

const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: {
		setPaymentType: (state, action) => {
			state.paymentType = action.payload;
		},
		setPaymentMethod: (state, action) => {
			state.paymentMethod = action.payload;
		},
		clearCheckout: () => initialState,
	},
});

export const { setPaymentType, setPaymentMethod, clearCheckout } = checkoutSlice.actions;

export default checkoutSlice.reducer;
